import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const A_COMPLETER = <span className="font-semibold text-amber-700">[À COMPLÉTER]</span>;

const MENTIONS = (
  <>
    <h2>Éditeur du site</h2>
    <p>Jeff Connect est édité par <b>Jeff P Dental LLC</b>, société à responsabilité limitée
      (<i>Limited Liability Company</i>) de droit américain, immatriculée auprès du Secrétariat d'État
      du Nouveau-Mexique (États-Unis) sous le numéro <b>3052734</b> (EIN&nbsp;: 35-2897160),
      dont le siège social est situé 1209 Mountain Road Pl NE, Suite N, Albuquerque, NM 87110, États-Unis.</p>
    <p>Directeur de la publication : Jérôme Levy, gérant (<i>Managing Member</i>).
      Contact : jeff@jeffpdental.com (email) — +1 (505) 301-1071 (téléphone).</p>
    <h2>Hébergement</h2>
    <p>L'application est hébergée par <b>Emergent</b> (emergent.sh), plateforme d'hébergement cloud.
      Coordonnées complètes de l'hébergeur : {A_COMPLETER} (informations officielles à obtenir auprès de
      support@emergent.sh).</p>
    <h2>Propriété intellectuelle</h2>
    <p>L'ensemble des éléments de la plateforme Jeff Connect (structure, textes, logos, interfaces) est protégé
      par le droit de la propriété intellectuelle. Toute reproduction non autorisée est interdite.</p>
    <h2>Signalement</h2>
    <p>Pour tout signalement relatif au contenu ou au fonctionnement de la plateforme : jeff@jeffpdental.com.</p>
  </>
);

const CGU = (
  <>
    <h2>1. Objet</h2>
    <p>Les présentes Conditions Générales d'Utilisation (CGU) encadrent l'accès et l'usage de la plateforme
      Jeff Connect, service d'intermédiation sécurisé entre cabinets dentaires et la société <b>Jeff P Dental LLC</b> pour
      la commande, le suivi de fabrication et la livraison de dispositifs médicaux sur mesure (prothèses dentaires).</p>
    <h2>2. Accès au service</h2>
    <p>L'accès est réservé aux professionnels (cabinets dentaires, laboratoires partenaires) disposant d'un compte
      validé par l'administrateur. Chaque utilisateur est responsable de la confidentialité de ses identifiants.
      L'inscription des cabinets est soumise à validation.</p>
    <h2>3. Rôle d'intermédiaire</h2>
    <p>Jeff Connect agit en qualité d'intermédiaire unique : les cabinets et les laboratoires de fabrication n'entrent
      pas en relation directe via la plateforme. Toute tentative de contournement de cette intermédiation
      (échange de coordonnées, négociation directe) constitue un manquement contractuel pouvant entraîner la
      suspension du compte.</p>
    <h2>4. Commandes et fichiers</h2>
    <p>Le praticien est responsable de l'exactitude des informations transmises (teinte, matériau, empreintes
      numériques, photos). Les fichiers sont conservés 90 jours après la clôture du dossier,
      puis supprimés automatiquement conformément à la politique de conservation ; les métadonnées du dossier
      (traçabilité) sont conservées.</p>
    <h2>5. Dispositifs médicaux et conformité</h2>
    <p>Chaque dispositif livré est accompagné d'un certificat de conformité émis par le fabricant conformément à la
      réglementation applicable aux dispositifs médicaux sur mesure (Règlement (UE) 2017/745). Le praticien demeure
      responsable de la vérification clinique avant pose.</p>
    <h2>6. Facturation et paiement</h2>
    <p>Les prix applicables sont ceux de la grille tarifaire convenue avec chaque cabinet. Les factures sont émises
      par Jeff P Dental LLC en fin de mois et sont payables <b>immédiatement à réception</b>, par carte bancaire,
      virement SEPA (via Stripe) ou virement Wise.</p>
    <h2>7. Disponibilité</h2>
    <p>L'éditeur s'efforce d'assurer une disponibilité continue du service, sans garantie de fonctionnement
      ininterrompu. Des sauvegardes quotidiennes sont réalisées.</p>
    <h2>8. Responsabilité</h2>
    <p>Jeff P Dental LLC est tenue à une obligation de moyens. Sa responsabilité ne saurait être engagée en cas :
      d'utilisation non conforme du service ; de données ou fichiers erronés, incomplets ou insuffisamment
      pseudonymisés transmis par l'utilisateur ; d'indisponibilité temporaire du service, notamment pour
      maintenance ; de faits imputables à un tiers ou de force majeure. Le praticien demeure seul responsable de
      ses choix thérapeutiques, de la prescription et de la vérification clinique du dispositif avant pose.
      En toute hypothèse, la responsabilité de l'éditeur, toutes causes confondues, est plafonnée au montant des
      sommes effectivement facturées au cabinet concerné au cours des douze (12) derniers mois. Aucune des parties
      ne répond des dommages indirects (perte d'exploitation, préjudice d'image). Ces stipulations ne limitent
      pas la responsabilité du fabricant au titre de la réglementation sur les dispositifs médicaux.</p>
    <h2>9. Résiliation</h2>
    <p>La relation contractuelle peut prendre fin à tout moment, sans préavis ni formalité, par simple arrêt de
      l'adressage de travaux prothétiques par le cabinet. Les commandes en cours de fabrication sont menées à leur
      terme et les factures émises restent dues.</p>
    <h2>10. Droit applicable</h2>
    <p>Les présentes CGU sont régies par le droit de l'État du Nouveau-Mexique (États-Unis), lieu
      d'immatriculation de Jeff P Dental LLC. Tout litige relève des juridictions compétentes de l'État du
      Nouveau-Mexique, sans préjudice des dispositions impératives protégeant les professionnels établis dans
      l'Union européenne.</p>
    <p className="italic">Version du {new Date().toLocaleDateString('fr-FR')} — document à faire valider par un conseil juridique avant mise en production.</p>
  </>
);

const CONFIDENTIALITE = (
  <>
    <h2>1. Responsable de traitement</h2>
    <p><b>Jeff P Dental LLC</b>, société de droit américain immatriculée au Nouveau-Mexique (n° 3052734),
      dont le siège est situé 1209 Mountain Road Pl NE, Suite N, Albuquerque, NM 87110, États-Unis, est
      responsable des traitements de données à caractère personnel réalisés via la plateforme Jeff Connect.</p>
    <p>Point de contact pour toute question relative aux données personnelles : <b>jeff@jeffpdental.com</b>.
      Aucun délégué à la protection des données (DPO) n'a été désigné à ce jour, les traitements ne relevant pas
      des cas de désignation obligatoire de l'article 37 du RGPD ; cette analyse est réévaluée périodiquement.</p>

    <h2>2. Champ d'application</h2>
    <p>La présente politique s'applique à tous les utilisateurs professionnels de la plateforme (cabinets
      dentaires, laboratoires partenaires, administrateurs) ainsi qu'aux données pseudonymisées de patients
      traitées pour le compte des praticiens. Les cabinets étant établis dans l'Union européenne, le Règlement
      (UE) 2016/679 (« RGPD ») s'applique à l'ensemble de ces traitements en vertu de son article 3.</p>

    <h2>3. Données traitées</h2>
    <ul>
      <li><b>Données d'identification professionnelle</b> : nom, prénom, email, téléphone et adresse
        professionnels des praticiens, des cabinets et des laboratoires ; identifiants de connexion
        (mot de passe stocké de manière sécurisée).</li>
      <li><b>Données patients — pseudonymisées</b> : référence interne attribuée par le cabinet, teinte,
        dents concernées, empreintes numériques (fichiers STL), photos cliniques et instructions de fabrication.
        La plateforme <b>n'exige et ne collecte aucune donnée d'identification directe du patient</b> (ni nom,
        ni date de naissance, ni numéro de sécurité sociale) ; le praticien s'engage contractuellement à
        n'utiliser qu'une référence interne. Seul le cabinet prescripteur détient la table de correspondance.</li>
      <li><b>Données de facturation</b> : grilles tarifaires, factures, statuts de paiement.</li>
      <li><b>Données techniques et de traçabilité</b> : journaux de connexion, horodatage des actions,
        historique des statuts de chaque dossier (exigence de traçabilité des dispositifs médicaux),
        jetons de notifications push (si activées par l'utilisateur).</li>
    </ul>

    <h2>4. Finalités et bases légales</h2>
    <ul>
      <li><b>Gestion des commandes, fabrication et livraison</b> — exécution du contrat
        (art. 6.1.b RGPD).</li>
      <li><b>Traitement de données de santé pseudonymisées</b> — nécessaire à la prise en charge sanitaire et
        à la fabrication de dispositifs médicaux sur mesure sous la responsabilité de professionnels de santé
        soumis au secret (art. 9.2.h RGPD), avec pseudonymisation comme garantie complémentaire.</li>
      <li><b>Traçabilité des dispositifs médicaux et certificats de conformité</b> — obligation légale
        (art. 6.1.c RGPD ; Règlement (UE) 2017/745).</li>
      <li><b>Facturation et comptabilité</b> — obligation légale (art. 6.1.c RGPD).</li>
      <li><b>Sécurité de la plateforme, prévention de la fraude, journalisation</b> — intérêt légitime
        (art. 6.1.f RGPD).</li>
      <li><b>Notifications push et emails de service</b> — exécution du contrat ; les notifications push ne
        sont activées qu'à la demande de l'utilisateur et sont désactivables à tout moment.</li>
    </ul>

    <h2>5. Durées de conservation</h2>
    <ul>
      <li><b>Fichiers des dossiers</b> (empreintes, photos, documents joints) : <b>90 jours</b> après la clôture
        du dossier, puis suppression automatique et définitive.</li>
      <li><b>Métadonnées de traçabilité et certificats de conformité</b> : 10 ans à compter de la mise sur le
        marché du dispositif, conformément à l'annexe XIII du Règlement (UE) 2017/745 relatif aux dispositifs
        sur mesure (15 ans pour les dispositifs implantables).</li>
      <li><b>Données de facturation et pièces comptables</b> : 10 ans.</li>
      <li><b>Comptes utilisateurs</b> : durée de la relation contractuelle, puis archivage restreint 5 ans
        (prescription légale).</li>
      <li><b>Journaux de connexion</b> : 12 mois maximum.</li>
    </ul>

    <h2>6. Destinataires et sous-traitants</h2>
    <p>Les données de fabrication d'un dossier sont transmises <b>au seul laboratoire chargé de ce dossier</b>,
      sans divulgation de l'identité ni des coordonnées du cabinet (principe d'intermédiation). Réciproquement,
      l'identité du laboratoire n'est pas communiquée au cabinet. Aucune donnée n'est vendue, louée ou cédée à
      des tiers à des fins commerciales.</p>
    <p>Sous-traitants techniques (art. 28 RGPD), liés par des engagements de confidentialité et de sécurité :
      hébergement — Emergent (emergent.sh) ; envoi d'emails transactionnels — Twilio SendGrid ; traduction
      automatique des instructions libres (textes non identifiants uniquement) ; stockage chiffré des
      sauvegardes. La liste à jour des sous-traitants est disponible sur demande à jeff@jeffpdental.com.</p>

    <h2>7. Transferts hors Union européenne</h2>
    <p>Le responsable de traitement est établi aux États-Unis et les laboratoires partenaires peuvent être
      situés hors de l'Union européenne (notamment en Asie). Ces transferts (art. 44 et s. RGPD) sont encadrés
      par les garanties suivantes :</p>
    <ul>
      <li><b>Minimisation stricte</b> : seules des données pseudonymisées, limitées au nécessaire de
        fabrication, quittent l'Union ; aucune donnée d'identification directe de patient n'est traitée.</li>
      <li><b>Clauses contractuelles types</b> de la Commission européenne (décision d'exécution (UE) 2021/914)
        intégrées aux contrats conclus avec chaque laboratoire partenaire et sous-traitant concerné.</li>
      <li><b>Mesures techniques complémentaires</b> : chiffrement des données en transit (TLS), contrôle
        d'accès par rôle, journalisation des accès, suppression automatique à 90 jours.</li>
    </ul>

    <h2>8. Sécurité</h2>
    <p>Conformément à l'article 32 du RGPD : chiffrement des échanges (HTTPS/TLS), politique de sécurité de
      contenu stricte (CSP), mots de passe stockés sous forme hachée, cloisonnement strict des données entre
      cabinets et entre laboratoires, contrôle d'accès par rôle, journalisation exhaustive des actions,
      sauvegardes quotidiennes chiffrées et vérifiées avec tests de restauration, suppression automatique des
      fichiers expirés.</p>

    <h2>9. Cookies et traceurs</h2>
    <p>Jeff Connect n'utilise <b>aucun cookie publicitaire ni traceur de mesure d'audience tiers</b>. Seuls des
      traceurs strictement nécessaires au fonctionnement du service sont utilisés (jeton de session sécurisé,
      préférences locales, cache hors-ligne de l'application mobile) ; ils sont exemptés de consentement au sens
      de la réglementation applicable.</p>

    <h2>10. Violation de données</h2>
    <p>En cas de violation de données susceptible d'engendrer un risque pour les droits et libertés des
      personnes, le responsable de traitement notifiera l'autorité de contrôle compétente dans les 72 heures
      (art. 33 RGPD) et informera les utilisateurs concernés lorsque le risque est élevé (art. 34 RGPD).</p>

    <h2>11. Vos droits</h2>
    <p>Conformément aux articles 15 à 21 du RGPD, vous disposez des droits d'accès, de rectification,
      d'effacement, de limitation du traitement, de portabilité et d'opposition, ainsi que du droit de définir
      des directives relatives au sort de vos données après votre décès. Pour les exercer, écrivez à
      <b> jeff@jeffpdental.com</b> en justifiant de votre identité ; une réponse vous sera apportée dans un
      délai d'un mois. Les demandes relatives aux données d'un patient doivent être adressées au cabinet
      prescripteur, seul détenteur de la correspondance entre la référence interne et l'identité du patient.
      Vous pouvez introduire une réclamation auprès de la CNIL (www.cnil.fr) ou de l'autorité de contrôle de
      votre État membre.</p>

    <h2>12. Mise à jour de la présente politique</h2>
    <p>Cette politique peut être mise à jour pour refléter les évolutions du service ou de la réglementation ;
      la version en vigueur est celle publiée sur cette page, avec sa date. En cas de modification substantielle,
      les utilisateurs en sont informés via la plateforme.</p>

    <p className="italic">Version du {new Date().toLocaleDateString('fr-FR')} — document à faire relire par un
      conseil juridique avant mise en production.</p>
  </>
);

const PAGES = {
  '/mentions-legales': { title: 'Mentions légales', body: MENTIONS },
  '/cgu': { title: "Conditions Générales d'Utilisation", body: CGU },
  '/confidentialite': { title: 'Politique de confidentialité', body: CONFIDENTIALITE },
};

export default function LegalPage() {
  const { pathname } = useLocation();
  const page = PAGES[pathname] || PAGES['/mentions-legales'];
  return (
    <div className="min-h-screen bg-background" data-testid="legal-page">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Link to="/login" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-6" data-testid="legal-back-btn">
          <ArrowLeft className="h-4 w-4" />Retour
        </Link>
        <h1 className="text-2xl sm:text-3xl font-bold mb-6">{page.title}</h1>
        <div className="prose prose-sm max-w-none [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:mt-6 [&_h2]:mb-2 [&_p]:text-sm [&_p]:leading-relaxed [&_p]:mb-3 [&_ul]:text-sm [&_ul]:list-disc [&_ul]:pl-5 [&_li]:mb-1 text-foreground/90">
          {page.body}
        </div>
        <div className="mt-8 pt-4 border-t border-border flex gap-4 text-xs text-muted-foreground">
          <Link to="/mentions-legales" className="hover:underline">Mentions légales</Link>
          <Link to="/cgu" className="hover:underline">CGU</Link>
          <Link to="/confidentialite" className="hover:underline">Confidentialité</Link>
        </div>
      </div>
    </div>
  );
}
